export default (state = {}) => {
  return {
    ...state,
    allReportState: {},
    allReportData: {},
    allReportMeta: {},
    allOrdersData: {},
    allOrdersMeta: {},
    allReportRecordData: {},
  };
};
